import ContactFormSection from '#/features/contact/components/ContactFormSection'
import ContactCommitmentsSection from '#/features/contact/components/ContactCommitmentsSection'
import ContactHeroSection from '#/features/contact/components/ContactHeroSection'
import PageTransition from '#/components/common/PageTransition'

export default function ContactPage() {
  return (
    <PageTransition>
      <main className="relative flex flex-col">
        <ContactHeroSection />
        <ContactFormSection />
        <ContactCommitmentsSection />
      </main>
    </PageTransition>
  )
}
